const icons = {};

const importAll = (requireContext) => {
  requireContext.keys().forEach((fileName) => {
    const iconName = fileName.replace('./', '').replace('.svg', '');
    icons[iconName] = requireContext(fileName);
  });
};

importAll(require.context('./', false, /\.svg$/));

console.log(icons)

export default icons;
